import {
  TAdaptor,
  TTrackEvent,
  TSetUser,
  IHydrateAdaptorPayload,
  IHydratedAdaptor,
  EAdaptors,
  EEventTypes,
  TTRACKED_EVENTS,
} from '../types';
import hydrateAdaptor from '../hydrateAdaptor';

declare const window: Window & { dataLayer: Array<Record<string, unknown>> };

const TRACKED_EVENTS: TTRACKED_EVENTS = {
  [EEventTypes.REGISTRATION_COMPLETE]: ['config', 'AW-385601856'],
  // [EEventTypes.EVERGREEN_UA_REGISTRATION_COMPLETE]: ['config', 'AW-*'],
  // [EEventTypes.EVERGREEN_UA_EMAIL_SIGNUP_COMPLETE]: ['config', 'AW-*'],
  // [EEventTypes.PROJECT_SPECIFIC_UA_REGISTRATION_COMPLETE]: ['config', 'AW-*'],
  // [EEventTypes.PROJECT_SPECIFIC_UA_EMAIL_SIGNUP_COMPLETE]: ['config', 'AW-*'],
};

export const gtmAdaptor: TAdaptor = (adaptorPayload) => {
  const { enabled } = adaptorPayload.config;

  if (!enabled) {
    return undefined;
  }

  const trackEvent: TTrackEvent = (payload) => {
    const { eventName } = payload;
    if (!(eventName in TRACKED_EVENTS)) {
      return;
    }
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    window.dataLayer.push(TRACKED_EVENTS[eventName]);
  };

  const hydrateAdaptorPayload: IHydrateAdaptorPayload = {
    trackEvent,
  };

  const baseAdaptor: IHydratedAdaptor = hydrateAdaptor(hydrateAdaptorPayload);

  const setUser: TSetUser = (currentUser) => {
    const userId = currentUser.id;
    if (userId && !window.dataLayer.some((item: any) => item.user_id)) {
      window.dataLayer.push({ user_id: userId || null });
    }
  };

  const finalAdaptor: IHydratedAdaptor = {
    ...baseAdaptor,
    setUser,
  };

  return finalAdaptor;
};

gtmAdaptor.NAME = EAdaptors.GTM;

export default gtmAdaptor;
